// extracted by mini-css-extract-plugin
export default {"zoomModal":"O1-z"};